import { render, staticRenderFns } from "./ShopOrdersManage.vue?vue&type=template&id=57fb3410&scoped=true&"
import script from "./ShopOrdersManage.vue?vue&type=script&lang=js&"
export * from "./ShopOrdersManage.vue?vue&type=script&lang=js&"
import style0 from "./ShopOrdersManage.vue?vue&type=style&index=0&id=57fb3410&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fb3410",
  null
  
)

export default component.exports